import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from '../../../context/language';
import axios from '../../../utils/axios';
import LoadingSpinner from '../../atoms/LoadingSpinner';
import HistoryCard from '../../molecules/HistoryCard';
import {parsePhoneNumber} from 'libphonenumber-js';
import {RootState} from '../../../redux/reducers';
import Text from '../../atoms/Text';

const History = () => {
  const {text} = useTranslation();
  const {currentWatchChannel, id} = useSelector((state: RootState) => ({
    ...state.channel,
    ...state.user,
  }));
  const [historyData, setHistoryData] = useState([]);
  const [loaded, setLoaded] = useState(false)

  const getData = () => {
    const data = {
      sender: {
        dialCountryCode: '',
        mobileNumber: '',
      },
      recipient: {
        dialCountryCode: '',
        mobileNumber: '',
      },
      skip: 0,
      first: 0
    };
    currentWatchChannel?.members.forEach(member => {
      const currId = member.user?.id;
      const user = member.user;
      const currPhoneNum = parsePhoneNumber(
        String(member.user?.phoneNumber) || '',
      );
      if (currId === id) {
        data.recipient.dialCountryCode = `+${String(
          currPhoneNum.countryCallingCode,
          )}`;
        data.recipient.mobileNumber = String(currPhoneNum.nationalNumber);
      } else {
        data.sender.dialCountryCode = `+${String(
          currPhoneNum.countryCallingCode,
        )}`;
        data.sender.mobileNumber = String(currPhoneNum.nationalNumber);
      }
    });
    return data;
  };


  const getHistory = async (data: any) => {
    const url = '/api/v1/remittance/widget/history/';
    const res = await axios.post(url, data);
    setHistoryData(res.data.remittances);
    setLoaded(true)
  };

  useEffect(() => {
    getHistory(getData());
  }, []);

  return (
    <>
      {historyData.length > 0 ? (
        historyData.map((singleData: any) => {
          const created = new Date(singleData.remittance.createdAt);

          const cardData = {
            firstName: singleData.remittance.sender.profile.firstName,
            lastName: singleData.remittance.sender.profile.lastName,
            valueSize: '2',
            day: created.getDate().toString(),
            month: text.months[created.getMonth()],
            stage: 'test',
            id: singleData.remittance.id || '',
            amount: singleData.remittance.extraInfo.receiving.amount,
            currency: singleData.remittance.extraInfo.receiving.currency,
            description: 'test',
            entireData: singleData.remittance,
            codeRemittance: singleData.remittance.extraInfo.codeRemittance,
          };
          return <HistoryCard key={cardData.id} data={cardData} />;
        })
      ) : ( loaded ? <Text textAlign={'center'}>{text.noRemittances}</Text> :
        <LoadingSpinner small={true} width={50} height={50} />
      )}
    </>
  );
};

export default History;
